import { createContext } from 'react';
import { datadogRum } from '@datadog/browser-rum';

const DatadogRumContext = createContext(datadogRum);

export { DatadogRumContext };
//# sourceMappingURL=context.js.map
